import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ClipboardModule } from 'ngx-clipboard';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AvatarModule, SvgModule } from '@mitel-internal/cloudlink-components-catalogue'; 
import { MaterialModule } from '.';
import { ClDropdownComponent } from './components/cl-dropdown/cl-dropdown.component';
import { ClErrorAlertComponent } from './components/cl-error-alert/cl-error-alert.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { MiniSpinnerComponent } from './components/mini-spinner/mini-spinner.component';
import { ConfirmationDialogComponent } from './components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { InformationDialogComponent } from './components/dialogs/information-dialog/information-dialog.component';
import { ErrorDetailsDialogComponent } from './components/dialogs/error-details-dialog/error-details-dialog.component';
import { CopyTextDialogComponent } from './components/dialogs/copy-text-dialog/copy-text-dialog.component';
import { AbsentIntegNotifierComponent } from './components/absent-integ-notifier/absent-integ-notifier.component';
import { DisplacerComponent } from './components/displacer/displacer.component';
import { DisplacerPortalDirective } from './directives/displacer-portal.directive';

import { GenericToggleFieldComponent } from './components/generic-toggle-field/generic-toggle-field.component';
import { CopyFadeButtonComponent } from './components/copy-fade-button/copy-fade-button.component';
import { RBACDirective } from './directives/rbac.directive';
import { GenericItemSearchControlsComponent } from './components/generic-item-search-controls/generic-item-search-controls.component';
import { SkillsFilterComponent } from './components/skills-filter/skills-filter.component';
import { CompanyNameDropdownComponent } from './components/company-name-dropdown/company-name-dropdown.component';
import { FormAlertComponent } from './components/form-alert/form-alert.component';
import { NavigationErrorComponent } from './components/navigation-error/navigation-error.component';
import { NotifyAlertComponent } from './components/notify-alert/notify-alert.component';
import { ProgressIndicatorPopupComponent } from './components/progress-indicator-popup/progress-indicator-popup.component';
import { SpinnerButtonComponent } from './components/spinner-button/spinner-button.component';
import { TooltipContentComponent } from './components/tooltip/tooltip-content/tooltip-content.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { FeatureTableComponent } from './components/feature-table/feature-table.component';
import { SortbyPipe } from './pipes/sortby.pipe';
import { GooglePlacesDirective } from './directives/google-places.directive';
import { TooltipDirective } from './directives/tooltip.directive';
import { TooltipService } from './services/tooltip.service';
import { FilterBundles } from './pipes/filterBundles.pipe';
import { SearchableDropdownComponent } from './components/searchable-dropdown/searchable-dropdown.component';
import { ColumnEditorDialogComponent } from './components/dialogs/column-editor-dialog/column-editor-dialog.component';
import { ExternalRefreshNotifierComponent } from './components/external-refresh-notifier/external-refresh-notifier.component';
import { BannerComponent } from './components/banner/banner.component';
import { UIPreviewBannerComponent } from './components/ui-preview-banner/ui-preview-banner.component';

@NgModule({
    declarations: [
        ClDropdownComponent,
        ClErrorAlertComponent,
        SpinnerComponent,
        MiniSpinnerComponent,
        ConfirmationDialogComponent,
        InformationDialogComponent,
        ErrorDetailsDialogComponent,
        AbsentIntegNotifierComponent,
        DisplacerComponent,
        GenericToggleFieldComponent,
        DisplacerPortalDirective,
        CopyFadeButtonComponent,
        RBACDirective,
        GenericItemSearchControlsComponent,
        SkillsFilterComponent,
        CompanyNameDropdownComponent,
        FormAlertComponent,
        NavigationErrorComponent,
        NotifyAlertComponent,
        ProgressIndicatorPopupComponent,
        SpinnerButtonComponent,
        TooltipContentComponent,
        TooltipComponent,
        FeatureTableComponent,
        SortbyPipe,
        FilterBundles,
        GooglePlacesDirective,
        TooltipDirective,
        SearchableDropdownComponent,
        CopyTextDialogComponent,
        ColumnEditorDialogComponent,
        ExternalRefreshNotifierComponent,
        BannerComponent,
        UIPreviewBannerComponent,
    ],
    imports: [
        CommonModule,
        MaterialModule,
        TranslateModule,
        ReactiveFormsModule,
        FormsModule,
        SvgModule,
        AvatarModule,
        ClipboardModule,
        InfiniteScrollModule,
        NgxIntlTelInputModule,
        NgxMatSelectSearchModule,
        NgbModule
    ],
    providers: [
        TooltipService
    ],
    exports: [
        MaterialModule,
        TranslateModule,
        ReactiveFormsModule,
        FormsModule,
        SvgModule,
        AvatarModule,
        ClipboardModule,
        InfiniteScrollModule,
        NgxIntlTelInputModule,
        NgxMatSelectSearchModule,
        NgbModule,
        ClDropdownComponent,
        ClErrorAlertComponent,
        SpinnerComponent,
        MiniSpinnerComponent,
        ConfirmationDialogComponent,
        InformationDialogComponent,
        AbsentIntegNotifierComponent,
        DisplacerComponent,
        DisplacerPortalDirective,
        GenericToggleFieldComponent,
        CopyFadeButtonComponent,
        RBACDirective,
        GenericItemSearchControlsComponent,
        CompanyNameDropdownComponent,
        FormAlertComponent,
        NavigationErrorComponent,
        NotifyAlertComponent,
        ProgressIndicatorPopupComponent,
        SpinnerButtonComponent,
        TooltipContentComponent,
        FeatureTableComponent,
        TooltipComponent,
        SortbyPipe,
        FilterBundles,
        GooglePlacesDirective,
        TooltipDirective,
        SearchableDropdownComponent,
        CopyTextDialogComponent,
        ColumnEditorDialogComponent,
        ExternalRefreshNotifierComponent,
        BannerComponent,
        UIPreviewBannerComponent,
    ]
})
export class SharedModule { }